import { lazy } from 'react';


export const CryptoCourse = lazy(() => import('./CryptoCourse'));
